import { useState, useEffect } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";

const Completion = ({
  Show,
  Hide,
  Title,
  subjectStatusLoader,
  updateStudySubjectStatus,
  completionDate,
  setCompletionDate
}) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-3">
          <Form.Label className="mb-1 fw-semibold">
            Completion Date <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="date"
            value={completionDate}
            onChange={(e) => setCompletionDate(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={!completionDate || subjectStatusLoader}
          className="updateProfile"
          onClick={updateStudySubjectStatus}
        >
          {subjectStatusLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Completing...
            </div>
          ) : (
            "Mark Complete"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default Completion;
